.root {
  display: flex;
  flex-direction: column;
  gap: var(--spacingLg);
}

.divider {
  margin: var(--spacingLg) 0;
}
